namespace Recommendations {
    function HouseRecommender(houseRecommender:any) {
        return {
            scope: {
                wrapperClass: '@'
            },
            templateUrl: 'partials/recommendations/houserecommender',
            link($scope) {
                houseRecommender
                    .getHouseRecs()
                    .then(destinations => _.assign(
                    $scope,
                    {
                        destinations,
                        track: houseRecommender.trackHouseClick
                    }
                ));
            }
        };
    }

    angular
        .module('recommendations')
        .directive('houseRecommender', HouseRecommender);
}
